import { CoreAdminRouter } from 'ra-core';
import { Loading } from 'ra-ui-materialui';
var AdminRouter = CoreAdminRouter;
AdminRouter.defaultProps = {
    loading: Loading,
};
export default AdminRouter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-admin/esm/AdminRouter.js
// module id = 1399
// module chunks = 0